import React, { useState } from 'react';
import './Contact.css';

const FORMSPREE_URL = 'https://formspree.io/f/xlgoobky';

const Contact: React.FC = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState<'idle' | 'sending' | 'success' | 'error'>('idle');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('sending');
    try {
      const res = await fetch(FORMSPREE_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(formData),
      });
      if (res.ok) {
        setStatus('success');
        setFormData({ name: '', email: '', message: '' });
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  return (
    <div className="contact">
      <section className="section">
        <div className="container">
          <h2>Contact</h2>
          <div className="contact-grid">
            <div className="contact-info">
              <p><strong>EuroJDM Auto Inc.</strong></p>
              <p>104-6295B Mississauga Rd<br />Mississauga, ON L5N 1A5</p>
              <p>Phone: <a href="tel:6473671603">647 367 1603</a></p>
              <p>Email: <a href="mailto:eurojdmauto@gmail.com">eurojdmauto@gmail.com</a></p>
            </div>

            <div className="contact-form-wrapper">
              {status === 'success' ? (
                <div className="form-success">
                  <p>Message sent — we'll be in touch shortly.</p>
                </div>
              ) : (
                <form className="contact-form" onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label htmlFor="name">Name *</label>
                    <input type="text" id="name" name="name" value={formData.name} onChange={handleInputChange} required />
                  </div>
                  <div className="form-group">
                    <label htmlFor="email">Email *</label>
                    <input type="email" id="email" name="email" value={formData.email} onChange={handleInputChange} required />
                  </div>
                  <div className="form-group">
                    <label htmlFor="message">Message *</label>
                    <textarea id="message" name="message" value={formData.message} onChange={handleInputChange} rows={5} required></textarea>
                  </div>
                  {status === 'error' && (
                    <p className="form-error">Something went wrong. Please try again or email us directly.</p>
                  )}
                  <button type="submit" className="btn btn-primary form-submit" disabled={status === 'sending'}>
                    {status === 'sending' ? 'Sending...' : 'Submit'}
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
